import {lazy} from 'react';
import {Outlet} from 'react-router-dom';
import {IssuerGuard} from 'src/guards/issuer-guard';
import {GuestGuard} from 'src/guards/guest-guard';
import {Layout as AuthLayout} from 'src/layouts/auth/modern-layout';
import {Layout as ChangePasswordLayout} from 'src/layouts/auth/change-password-layout';
import {Issuer} from 'src/utils/auth';

const LoginPage = lazy(() => import('src/pages/auth/login'));
const PageChangePassword = lazy(() => import('src/pages/auth/change-password'));


export const authRoutes = [
    {
        path: 'auth',
        children: [
            {
                path: 'appAuth',
                element: (
                    <IssuerGuard issuer={Issuer.appAuth}>
                        <GuestGuard>
                            <AuthLayout>
                                <Outlet/>
                            </AuthLayout>
                        </GuestGuard>
                    </IssuerGuard>
                ),
                children: [
                    {
                        path: 'login',
                        element: <LoginPage/>
                    },

                ]
            }
        ]
    },
    {
        path: 'changePassword',
        element: <ChangePasswordLayout>
            <PageChangePassword />
        </ChangePasswordLayout>
    },
];
